import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { AppRootStateType } from 'state';

export const useAppSelector: TypedUseSelectorHook<AppRootStateType> = useSelector;
